<template>
  <b-pagination
    v-model="currentPage"
    :total-rows="totalRows"
    :per-page="resultsPerPage"
    aria-controls="my-table"
    hide-goto-end-buttons
    hide-ellipsis
    limit="10"
    prev-text="Prev"
    next-text="Next"
    v-show="totalRows"
    class="the-pagination d-none d-md-flex"
    @change="update"
  ></b-pagination>
</template>
<script>

export default {
  props: ['totalRows', 'paginationChange'],
  data: () => ({
    currentPage: 1,
    resultsPerPage: 10
  }),
  methods: {
    update(event) {
      this.$emit('paginationChange', event);
    }
  }
}
</script>